//remove_cart_start
$('.clear-cart-btn').on('click',function(e){
    e.preventDefault();
    $.ajax({
      type: "POST",
      url: '/cart/clear.js',
      success: function(){
        document.location.reload(true)
        
      },
      dataType: 'json'
    });
  })
//remove_cart_end

//login-start

var emailErr = "",
  pswErr = "";
$(".loginEmail").keyup(function () {
  $("#customer_login").attr("onsubmit", "");
  let email = $(this).val();
  emailErr = checkLoginEmail(email);
});
$(".loginPassword").keyup(function () {
  $("#customer_login").attr("onsubmit", "");
  let psw = $(this).val();
  pswErr = checkLoginPsw(psw);
});
$(".form-login").click(function (e) {
  e.preventDefault();
  var email = $(".loginEmail").val();
  var psw = $(".loginPassword").val();
  emailErr = checkLoginEmail(email);
  pswErr = checkLoginPsw(psw);
  if (emailErr === true && pswErr === true) {
    $("#customer_login").submit();
  }
});

var emailRevErr = "";
function checkRecoveryEmail(email) {
  if (email === "") {
    $("#RecoverEmail-email-error")
      .removeClass("custom-hide")
      .addClass("custom-show");
    $("#RecoverEmail-email-error").html("This field is required.");
    return false;
  } else if (
    !email.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/) ||
    email.match(/^[0-9]/)
  ) {
    $("#RecoverEmail-email-error")
      .removeClass("custom-hide")
      .addClass("custom-show");
    $("#RecoverEmail-email-error").html("Invalid email.");
    return false;
    // $error1 = false;
  } else {
    $("#RecoverEmail-email-error")
      .removeClass("custom-hide")
      .addClass("custom-show");
    $("#RecoverEmail-email-error").html("");
    return true;
  }
}
$(".recover-email").keyup(function () {
  let email = $(this).val();
  emailRevErr = checkRecoveryEmail(email);
});
$(".submit-recovery").click(function (e) {
 console.log("fun")
  e.preventDefault();
  var email = $("#RecoverEmail").val();
  emailRevErr = checkRecoveryEmail(email);
   
  if (emailRevErr === true) {
    $(".recover_customer_password").submit();
  }
});

function checkLoginEmail(email) {
  if (email === "") {
    $("#LoginForm-email-error").html("This field is required.");
    return false;
  } else if (
    !email.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/) ||
    email.match(/^[0-9]/)
  ) {
    $("#LoginForm-email-error").html("Invalid email.");
    return false;
    // $error = false;
  } else {
    $("#LoginForm-email-error").html("");
    return true;
  }
}
function checkLoginPsw(psw) {
  if (psw === "") {
    $("#LoginForm-password-error").html("This field is required.");
    return false;
  } else {
    $("#LoginForm-password-error").html("");
    return true;
  }
}
//loginend


//register-begin
$(document).ready(function () {
  var fnameErr = "",
    lnameErr = "",
    emailErr = "",
    pswErr = "";
  $(".registerFirstName").keyup(function () {
    $("#RegisterForm").attr("onsubmit", "");
    let fname = $(this).val();
    fnameErr = checkFname(fname);
  });
  $(".registerLastName").keyup(function () {
    $("#RegisterForm").attr("onsubmit", "");
    let lname = $(this).val();
    lnameErr = checkLname(lname);
  });
  $(".registerEmail").keyup(function () {
    $("#RegisterForm").attr("onsubmit", "");
    let email = $(this).val();
    emailErr = checkEmail(email);
  });
  $(".registerPassword").keyup(function () {
    $("#RegisterForm").attr("onsubmit", "");
    let psw = $(this).val();
    pswErr = checkPsw(psw);
  });
  $(".form-submit").click(function (e) {
    $("#RegisterForm").attr("onsubmit", "");
    e.preventDefault();
    let error = false;

    var fname = $(".registerFirstName").val(),
      lname = $(".registerLastName").val(),
      email = $(".registerEmail").val(),
      psw = $(".registerPassword").val(),
      fnameErr = checkFname(fname),
      lnameErr = checkLname(lname),
      emailErr = checkEmail(email),
      pswErr = checkPsw(psw);
    if (
      fnameErr === true &&
      lnameErr === true &&
      emailErr === true &&
      pswErr === true
    ) {
      $("#RegisterForm").submit();
    }
  });

  function checkFname(fname) {
    if (fname === "") {
      $("#RegisterForm-fname-error").html("This field is required.");
      return false;
    } else if (!fname.match(/^[A-Za-z\s\-]+$/)) {
      $("#RegisterForm-fname-error").html(
        "Only letters and white space allowed."
      );
      return false;
    } else if (fname.length < 3) {
      $("#RegisterForm-fname-error").html("Length should be greater than 2.");
      return false;
    } else {
      $("#RegisterForm-fname-error").html("");
      return true;
    }
  }
  function checkLname(lname) {
    if (lname != "" && !lname.match(/^[A-Za-z\s\-]+$/)) {
      $("#RegisterForm-lname-error").html(
        "Only letters and white space allowed."
      );
      return false;
    } else if (lname != "" && lname.length < 3) {
      $("#RegisterForm-lname-error").html("Length should be greater than 2.");
      return false;
    } else {
      $("#RegisterForm-lname-error").html("");
      return true;
    }
  }
  function checkEmail(email) {
    if (email === "") {
      $("#RegisterForm-email-error").html("This field is required.");
      return false;
    } else if (
      !email.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/) ||
      email.match(/^[0-9]/)
    ) {
      $("#RegisterForm-email-error").html("Invalid email.");
      $error = false;
    } else {
      $("#RegisterForm-email-error").html("");
      return true;
    }
  }
  function checkPsw(psw) {
    if (psw === "") {
      $("#RegisterForm-password-error").html("This field is required.");
      return false;
    } else if (psw.length < 5) {
      $("#RegisterForm-password-error").html(
        "Password is too short (minimum is 5 characters)."
      );
      return false;
    } else {
      $("#RegisterForm-password-error").html("");
      return true;
    }
  }
});

//register-end


//contact-start
$(".ContactForm-name").keyup(function () {
  $(".contact-form").attr("onsubmit", "");
  let fname = $(this).val();
  fnameErr = checkCname(fname);
});
$(".ContactForm-body").keyup(function () {
  $(".contact-form").attr("onsubmit", "");
  let lname = $(this).val();
  lnameErr = checkMes(lname);
});
$(".ContactForm-email").keyup(function () {
  $(".contact-form").attr("onsubmit", "");
  let email = $(this).val();
  emailErr = checkCEmail(email);
});
/*
$(".ContactForm-phone").keyup(function () {
  $(".contact-form").attr("onsubmit", "");
  let psw = $(this).val();
  pswErr = checkPhn(psw);
});
*/
$(".contact-submit").click(function (e) {
  $(".contact-form").attr("onsubmit", "");
  e.preventDefault();
  let error = false;

  var cname = $(".ContactForm-name").val(),
    cmes = $(".ContactForm-body").val(),
    cemail = $(".ContactForm-email").val(),
    //cphn = $(".ContactForm-phone").val(),
    cnameErr = checkCname(cname),
    mesErr = checkMes(cmes),
    cemailErr = checkCEmail(cemail);
    //phnErr = checkPhn(cphn);
  if (
    cnameErr === true &&
    mesErr === true &&
    cemailErr === true 
  ) {
    console.log("submit")
    $(".contact-form").submit();
  }
  else{
    console.log("not submit")
  }
});
function checkCname(cname) {
  if (cname === "") {
    $(".nameerror").html("This field is required.");
    return false;
  } else if (!cname.match(/^[A-Za-z\s\-]+$/)) {
    $(".nameerror").html("Only letters, white space and dash allowed.");
    return false;
  } else if (cname.length < 3) {
    $(".nameerror").html("Length should be greater than 2.");
    return false;
  } else {
    $(".nameerror").html("");
    return true;
  }
}
function checkCEmail(cemail) {
  if (cemail === "") {
    $(".cnemailerror").html("This field is required.");
    return false;
  } else if (
    !cemail.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/) ||
    cemail.match(/^[0-9]/)
  ) {
    $(".cnemailerror").html("Invalid email.");
    $error = false;
  } else {
    $(".cnemailerror").html("");
    return true;
  }
}
function checkMes(cmes) {
  if (cmes === "") {
    $(".messerror").html("This field is required.");
    return false;
  } else {
    $(".messerror").html("");
    return true;
  }
}
/*
function checkPhn(cphn) {
  if (cphn === "") {
    $(".phnerror").html("This field is required.");
    return false;
  } else if (!cphn.match(/^[1-9]+[0-9]*$/)) {
    $(".phnerror").html("Invalid Number.");
    return false;
  } else {
    $(".phnerror").html("");
    return true;
  }
}
*/
//contact-end